import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearIncreaseCreditModalProps } from '../../../../../store/actions/modals';
import { getTranslation } from '../../../../../utils/translation';
import CloseButton from '../../CloseButton/CloseButton';
import Feedback from '../Feedback/Feedback';
import { increaseDebt } from '../../../../../store/actions/increase-reports';

const IncreaseCredit = () => {
    const dispatch = useDispatch();

    const modalProps = useSelector(state => state.modals.increaseCreditModal);

    const { successResponse, errorResponse, confirmation } = modalProps;

    const onClose = () => {
        hideModal();
    };

    const hideModal = () => {
        dispatch(clearIncreaseCreditModalProps());
    };

    const onConfirm = () => {
        dispatch(increaseDebt());
    };

    return (
        <>
            <CloseButton onClick={onClose} />
            {confirmation.message ? (
                <Feedback
                    onOk={onConfirm}
                    onClose={hideModal}
                    title={confirmation.message}
                    buttonText={getTranslation('increaseReportSuccessModalOkButton')}
                />
            ) : null}
            {successResponse.message ? (
                <Feedback
                    onClose={hideModal}
                    icon={'success'}
                    title={successResponse.message}
                    buttonText={getTranslation('increaseReportSuccessModalOkButton')}
                />
            ) : null}
            {errorResponse.message ? (
                <Feedback
                    onClose={hideModal}
                    title={errorResponse.message}
                    buttonText={getTranslation('increaseReportErrorModalGoBackButton')}
                />
            ) : null}
        </>
    );
};

export default IncreaseCredit;
